export default "__VITE_ASSET__DH$1aiWU__"